
import { FormattedRpServiceConfigurationServiceOffering } from "@idw-types/data/rp-service-configuration";
import { FormattedRpServiceConfigurationScoreModifier } from "@idw-types/data/rp-service-configuration/rp-service-configuration-score";
import { ScoreReferenceData } from "@idw-types/data/rp-service-configuration/scores/score-reference-data";
import { ScoreModifiersTableContainer } from "../../score-table-container/score-table-container";

type AssertionScoreModifiersTableContainerProps = {
    isDisabled: boolean;
    assertionScoreModifiers: Array<FormattedRpServiceConfigurationScoreModifier>;
    canViewPassAssertionScoreModifiers: boolean;
    canViewCloseAssertionScoreModifiers: boolean;
    canViewPartialAssertionScoreModifiers: boolean;
    canViewUnverifiedAssertionScoreModifiers: boolean;
    canViewFailAssertionScoreModifiers: boolean;
    scoreReferenceData: ScoreReferenceData;
    formattedServiceOfferings: Array<
        FormattedRpServiceConfigurationServiceOffering
    >;
    setAssertionScoreModifiersState: (
        assertionScoreModifiers: Array<FormattedRpServiceConfigurationScoreModifier>
    ) => void;
};

export type AssertionScoreModifierTableDataRow = FormattedRpServiceConfigurationScoreModifier & {
    assertionName: string;
    serviceOfferingName: string;
};

export const AssertionScoreModifiersTableContainer = (
    props: AssertionScoreModifiersTableContainerProps
) => {
    const {
        isDisabled,
        assertionScoreModifiers,
        canViewPassAssertionScoreModifiers,
        canViewCloseAssertionScoreModifiers,
        canViewPartialAssertionScoreModifiers,
        canViewUnverifiedAssertionScoreModifiers,
        canViewFailAssertionScoreModifiers,
        scoreReferenceData,
        formattedServiceOfferings,
        setAssertionScoreModifiersState,
    } = props;

    return (
        <ScoreModifiersTableContainer
            isDisabled={isDisabled}
            scoreModifiers={assertionScoreModifiers}
            canViewPassScoreModifiers={canViewPassAssertionScoreModifiers}
            canViewCloseScoreModifiers={canViewCloseAssertionScoreModifiers}
            canViewPartialScoreModifiers={canViewPartialAssertionScoreModifiers}
            canViewUnverifiedScoreModifiers={canViewUnverifiedAssertionScoreModifiers}
            canViewWarnScoreModifiers={false}
            canViewFailScoreModifiers={canViewFailAssertionScoreModifiers}
            assertions={scoreReferenceData.assertions}
            availableAssertionStatuses={scoreReferenceData.availableAssertionStatuses}
            availableScoreValues={scoreReferenceData.availableAssertionScoreValues}
            scoreAssertionStatusValueMaps={scoreReferenceData.assertionScoreAssertionStatusValueMaps}
            formattedServiceOfferings={formattedServiceOfferings}
            setScoreModifiersState={setAssertionScoreModifiersState}         />
    );
};
